//@flow
import * as assets from "./assets";
export default { assets };